import { NavLink, useLocation } from "react-router-dom";
import { LayoutDashboard, NotebookPen, MessagesSquare } from "lucide-react";

const TABS = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, testId: "nav-dashboard" },
  { to: "/journal", label: "Journal", icon: NotebookPen, testId: "nav-journal" },
  { to: "/chat", label: "Ask Harmonix", icon: MessagesSquare, testId: "nav-chat" },
];

export default function AppNav() {
  const { pathname } = useLocation();
  return (
    <nav
      className="w-full"
      style={{
        background: "rgba(250, 247, 242, 0.85)",
        borderBottom: "1px solid #E5DEC9",
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2 flex gap-1 overflow-x-auto">
        {TABS.map((t) => {
          const active = pathname === t.to || pathname.startsWith(t.to + "/");
          return (
            <NavLink
              key={t.to}
              to={t.to}
              data-testid={t.testId}
              className="inline-flex items-center gap-2 px-3.5 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap"
              style={{
                background: active ? "#2D5A4C" : "transparent",
                color: active ? "#FAF7F2" : "#1C2826",
                border: active ? "1px solid #23473C" : "1px solid transparent",
              }}
            >
              <t.icon size={15} />
              {t.label}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
